import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import AnnouncementBar from "./components/AnnouncementBar";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Designer from "./pages/Designer";
import Story from "./pages/Story";
import Checkout from "./pages/Checkout";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Policy from "./pages/Policy";
import Owner from "./pages/Owner";
import SabotageLookbook from "./pages/SabotageLookbook";

function Shell() {
  const location = useLocation();
  const bare = location.pathname.startsWith("/owner");
  return (
    <>
      <ScrollToTop />
      {!bare && <AnnouncementBar />}
      {!bare && <Navbar />}
      {!bare && <CartDrawer />}
      <div className={bare ? "" : "pt-9"}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/sabotage" element={<SabotageLookbook />} />
          <Route path="/product/:slug" element={<ProductDetail />} />
          <Route path="/designer" element={<Designer />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/about-the-trash" element={<Story kind="trash" />} />
          <Route path="/about-boothill" element={<Story kind="boothill" />} />
          <Route path="/shipping-returns" element={<Policy kind="shipping" />} />
          <Route path="/faq" element={<Policy kind="faq" />} />
          <Route path="/terms" element={<Policy kind="terms" />} />
          <Route path="/privacy" element={<Policy kind="privacy" />} />
          <Route path="/owner" element={<Owner />} />
        </Routes>
      </div>
      {!bare && <Footer />}
      <Toaster position="bottom-right" theme="dark" />
    </>
  );
}

function App() {
  return (
    <div className="App dark bg-background text-foreground min-h-screen">
      <BrowserRouter>
        <CartProvider>
          <Shell />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
